export const SKUNEXUS_FORGET_PASSWORD_CODE = 'forgetPassword';
export const SKUNEXUS_LOGIN_PATH = '/skunexus-login';
export const OKTA_LOGIN_PATH = '/okta-login';
export const OKTA_FAILED_PATH = '/okta-login-failed';
export const LOGIN_ERROR_COOKIE_NAME = 'skunexus-okta-login-error';
export const OKTA_BODY_ATTRIBUTE_NAME = 'data-okta-login';
